import React, { useState } from "react";
import ImageLazyLoading from "../ImageLazyLoad/ImageLazyLoading";
import { Box, Grid, MenuItem } from "@mui/material";
import "./style.css";
import { truncateString } from "../../Utils/stringtruncation";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { StyledMenu } from "../../Utils/StyledMenu";
import PropTypes from "prop-types"; // ES6
import Modal from "../Modal";
import DOMPurify from 'dompurify';
export const Widgets = ({ widgets }) => {
  const [selectedWidget, setselectedWidget] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [isOpen, setisOpen] = useState(false);

  const handleClick = (event, widget) => {
    setselectedWidget(widget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const WidgetsBody = () => {
    return (
      <p>{selectedWidget?.txt_media_streaming_link}</p>
      // <div
      //   dangerouslySetInnerHTML={{
      //     //SSBR
      //     __html:  DOMPurify.sanitize(selectedWidget?.txt_media_streaming_link),
      //   }}
      //   style={{ height: "100%" }}
      // />
    );
  };

  return (
    <>
      <Grid container spacing={2}>
        {widgets?.map((widget, i) => (
          <Grid item xs={12} md={4} lg={3} key={i}>
            <div
              onClick={() => {
                setselectedWidget(widget);
                setisOpen(true);
              }}
            >
              <ImageLazyLoading
                src={widget?.base64_media_thumbnail}
                alt={"img"}
                width={"100%"}
                height={"200px"}
                style={{ borderRadius: "8px", border: "3px solid #F0F0F0" }}
              />
            </div>
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              mt={1}
            >
              <span>{truncateString(widget?.txt_media_full_name, 8)}</span>
              <Box
                flexGrow={1}
                display={"flex"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                gap={1}
              >
                <div onClick={(e) => handleClick(e, widget)}>
                  <MoreVertIcon />
                </div>
              </Box>
            </Box>
          </Grid>
          // <Grid item xs={12} md={4} lg={3} key={i}>
          //   <div
          //     onClick={() => {
          //       setisOpen(true);
          //       setselectedWidget(widget.htmlIframe);
          //     }}
          //   >
          //     <ImageLazyLoading
          //       src={widget.thumbnail}
          //       width="100%"
          //       height="100%"
          //       alt="thumbnail"
          //     />
          //   </div>
          // </Grid>
        ))}
        <StyledMenu
          id="media-more-option"
          MenuListProps={{
            "aria-labelledby": "media-more-option",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <MenuItem disableRipple>Delete</MenuItem>
        </StyledMenu>
      </Grid>

      <Modal
        open={isOpen}
        onCloseModal={() => setisOpen(false)}
        padding={false}
      >
        {WidgetsBody()}
      </Modal>
      {/* <Modal
        open={isOpen}
        classNames={{
          overlayAnimationIn: "customEnterOverlayAnimation",
          overlayAnimationOut: "customLeaveOverlayAnimation",
          modalAnimationIn: "customEnterModalAnimation",
          modalAnimationOut: "customLeaveModalAnimation",
        }}
        onClose={() => setisOpen(false)}
        animationDuration={800}
        styles={{
          modal: {
            width: "90%",
            height: "70vh",
            padding: "unset",
            overflow: "hidden",
            borderRadius: "8px",
          },
          overlay: {
            background: "rgba(0, 0, 0, 0.5)",
          },
          closeButton: {
            background: "yellow",
            borderRadius: "50%",
          },
        }}
        center
      ></Modal> */}
    </>
  );
};

Widgets.propTypes = {
  widgets: PropTypes.arrayOf(PropTypes.object),
};
